module.exports = __webpack_public_path__ + "media/images/application/template/product-selector/wind-map-one-small-6111298126edd1d297d815edc2246686.jpg";